<template>
	<div class="IndexBox" style="background: url('./static/images/profile-bg.png');background-size: 100% 100%;height: 100%;width: 100%;">
	  <div class="ScrollBox">
		  <van-nav-bar
		    fixed
		    :border="false"
		    :title="$t('user.office[4]')"
		    left-arrow
		    @click-left="$router.go(-1)"
		  />
		<div style="padding-top:20%;text-align: center;">
			<!-- <div v-if="reData.post['pid']==100 && (reData.office==null || reData.office.state!=1)" style="background: rgb(255, 255, 255); border-radius: 25px; margin: 10px;height:300px;padding:10px;text-align: left;">
				<h4 style="font-size: 14px; font-weight: 800;">{{$t('positions.job[3]')}}</h4>
        		<div style="color: red;">{{$t('positions.job[4]')}}：</div>
				<div>1：{{$t('positions.job[5]')}}</div>
				<div>2：{{$t('positions.job[6]')}}</div>
				<div>3：{{$t('positions.job[7]')}}</div>
				<div style="margin-top:10px;display: flex;" v-if="reData.office==null || reData.office.state==2">
					<van-uploader v-model="img_1" :after-read="afterRead" :upload-text="$t('positions.job[9]')" :max-count="1" style="margin:0 auto;"/>
					<van-uploader v-model="img_2" :after-read="afterRead" :upload-text="$t('positions.job[10]')" :max-count="1" style="margin:0 auto;"/>
				</div>
				 <div style="margin-top:10px;display: flex;" v-else>
					<img :src="reData.office.img_1" style="width: 100px;height: 100px;margin:0 auto;"/>
					<img :src="reData.office.img_2" style="width: 100px;height: 100px;margin:0 auto;"/>
				</div>
				<van-button :disabled="reData.office==null || reData.office.state==2?false:true" round type="info" block 
				style="font-size: 16px;background: linear-gradient(to right, #37774C, #37774C);border:none;" @click="submitPostDebounce"> {{$t('positions.job[18]')}} </van-button
        >
			</div> -->
			<div v-for="(item,i) in reData" :key="i"  reData style="background: rgb(255, 255, 255); border-radius: 25px; margin: 10px;height:300px">
				<div style="padding:1rem 0 5% 0.3125rem;text-align: left;">{{$t('user.office[6]')}} ({{item.name}}) :</div>
				<div style="margin-top: 1rem;padding:0 0 0 0.3125rem;text-align: left;">{{$t('user.office[10]',{num:item.num2})}}</div>
				<div style="display: flex;width: 100%;padding: 0 10%;">
					<div v-for="(star, index) in 5" :key="index" >
					<img v-if="item.star >= index + 1" src="../images/full1.svg" alt="Full Star" style="width: 3.75rem;height: 3.75rem;">
					<img v-else src="../images/full.svg" alt="Empty Star" style="width: 3.75rem;height:3.75rem;">
					</div>
				</div>
				<div style="padding:0 0 5% 0.3125rem;text-align: left;">{{$t('user.office[9]',{num:item.num1})}}</div>
				<div style="padding: 5% 0 5% 0;">
					<van-progress strokeWidth="10" :pivotText="getStr(item.numberMembers,item.satisfy)" color="#03A9F4" :percentage="item.schedule" style="width: 95%;margin:0 auto;" />
				</div>
				<div style="width:90%;margin:0 auto;padding:10px;text-align: center; background: #37774C;color: #fff;" @click="openShow(item.star, item.schedule)">
				{{$t('user.office[5]')}}
				</div>
				<div v-if="reData.length==i+1">
						hello world
				</div>
			</div>
			
		  </div>
		  
		  
		</div>
	</div> 
</template>

<script>
import lodash from "lodash";
export default {
	name:"Job Promotion",
	data(){
		return {
			rating: 0,
			showCon: false,
			infoData:'',
			reData:[],
			schedule:100,
			img_1:[],
			img_2:[],
			formData:{
				img_1:"",
				img_2:"",
				postid:''
			},
		}
	},
	computed: {
	},
	watch: {
	},
	created() {
		this.$Model.GetUserInfo();
		this.$parent.navBarTitle = this.$t("user.office[4]")
		this.$Model.GetJobStatus(data=>{
		  if(data.code==1){
			this.reData = data.data;
		  }
		})
		
	},
	mounted() {
	},
	activated() {},
	destroyed() {},
	methods: {
		rate(event, newRating) {
		      this.rating = newRating;
		    },
		getStr(n1,n2) {
			
			//this.schedule = this.reData['schedule'];
			//this.rating = this.reData['star'];
			//return this.reData['numberMembers']+"/"+this.reData['satisfy'];
			return n1+"/"+n2;
		},
		openShow(star,schedule) {
			
			if(star < 5){
				return this.$Dialog.Toast(this.$t("user.office[8]"));
			}
			
			if(schedule != 100 ){
				this.$Dialog.Toast(this.$t("user.office[8]"));
			}else{
				this.$Model.Apply(data=>{
					this.$Dialog.Toast(data.msg);
					if(data.code==1){
						window.location.reload();
					} 
				});
			}
		  
		},
		afterRead(file) {
		this.uploadImgs(file);
		},
		uploadImgs(file){
			if (!file.file.type.match(/image/)){
				file.status = 'failed'
				file.message = 'failed'
				return;
			}
			this.$Util.CompressImg(file.file.type,file.content,750,(image)=>{
				let param = new FormData();
				param.append('token',localStorage['Token']);
				param.append('type',3);
				param.append('image',image,file.file.name);
				this.$Model.UploadImg(param,(data)=>{
				if(data.code==1){
					file.message = 'success'
					file.status = 'success'
					file.url = data.url
				}else{
					file.status = 'failed'
					file.message = 'failed'
				}
				});
			})
		},
		submitPostDebounce:lodash.debounce(function (){this.submitPost()},500),
		submitPost(){
			if(this.img_1.length>0){
				this.formData.img_1 = this.img_1[0].url
			}else{
				this.$Dialog.Alert(this.$t('positions.job[6]'));
				return;
			}
			if(this.img_2.length>0){
				this.formData.img_2 = this.img_2[0].url
			}else{
				this.$Dialog.Alert(this.$t('positions.job[7]'));
				return;
			}
			this.$Model.addPostAudit(this.formData,(res)=>{
				this.$Dialog.Toast(res.msg);
				if(res.code==1){
					window.location.reload();
				}
			})
		},
	}
}
	
</script>

<style scoped>
	.van-progress__pivot{font-size: 14px;}
span{text-wrap-mode:wrap;}
</style>